/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Main_AriaInputs */

const nl_nav_main_aria = /** @type {(inputs: Nav_Main_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoofdnavigatie`)
};

/**

* @param {Nav_Main_AriaInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const nav_main_aria = /** @type {((inputs?: Nav_Main_AriaInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Main_AriaInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_nav_main_aria(inputs)
});
export { nav_main_aria as "nav.main_aria" }